









import { Component, Inject, Model, Prop, Vue, Watch, Provide } from "vue-property-decorator";
import AlertView from './views/AlertView.vue';
import ConfirmView from './views/Confirm.vue';
import Tooltip from './components/Tooltip.vue';

@Component({
	components:{
		Tooltip,
		AlertView,
		ConfirmView,
	}
})
export default class App extends Vue {

	public mounted():void {
		
	}

	public beforeDestroy():void {
		
	}

}
